var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRashuthamisim(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-4 {\r\n        filter: url(#Path_221);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0.029,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9609"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffb109"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_221",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.388
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_154_29",
    "data-name": "Component 154 \\u2013 29",
    transform: "translate(4.5 4.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_417",
    "data-name": "Rectangle 417",
    className: "cls-1",
    width: 49,
    height: 63,
    rx: 24.5,
    transform: "translate(6)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4",
    transform: "matrix(1, 0, 0, 1, -4.5, -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_221-2",
    "data-name": "Path 221",
    className: "cls-2",
    d: "M31.5,0A31.5,31.5,0,1,1,0,31.5,31.5,31.5,0,0,1,31.5,0Z",
    transform: "translate(4.5 4.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_664",
    "data-name": "Group 664",
    transform: "translate(-871.104 -185.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    className: "cls-1",
    d: "M88.973,9.44a22.138,22.138,0,0,1,39.478,18.568A23.994,23.994,0,0,0,87.176,12.5a22.212,22.212,0,0,1,1.8-3.056",
    transform: "translate(795.473 190.542)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    className: "cls-1",
    d: "M18.3,174.59a22.139,22.139,0,0,1,.144-43.63,24,24,0,0,0,3.385,43.967,22.194,22.194,0,0,1-3.53-.338",
    transform: "translate(877.207 67.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    className: "cls-1",
    d: "M222.725,315.006a22.139,22.139,0,0,1-39.6,18.307,23.994,23.994,0,0,0,38.416-21.648,22.239,22.239,0,0,1,1.187,3.342",
    transform: "translate(705.515 -101.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    className: "cls-1",
    d: "M223.511,467.064v-1.2h-2.79v-1.332h-.83v1.82h2.866v1.154c0,1.109-1.942,1.586-1.942,3.249v.322h.755v-.765c0-1.109,1.942-1.6,1.942-3.25",
    transform: "translate(671.043 -244.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    className: "cls-1",
    d: "M292.18,491.08c-.406-.665-.82-1.331-1.235-1.985A5.45,5.45,0,0,0,292,486v-.133h-.716a4.533,4.533,0,0,1-.688,2.641,28.771,28.771,0,0,1-1.66-2.641h-.886l.914,1.431a12.268,12.268,0,0,0-.952,3.783h.716a13.062,13.062,0,0,1,.641-3.15,8.986,8.986,0,0,1,.839,1.253c.377.622.735,1.254,1.066,1.9h.9",
    transform: "translate(607.172 -264.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    className: "cls-1",
    d: "M367.952,489.239V486.61a2.424,2.424,0,0,0-2.442-2.707h-.245a4.648,4.648,0,0,0-.953.111l.142.542a1.859,1.859,0,0,1,1.046-.276c1.094,0,1.622,1.11,1.622,2.274v2.684h.829",
    transform: "translate(535.635 -263.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    className: "cls-3",
    d: "M441.487,485.866h-.773c-.018.888-.085,1.775-.151,2.651-.085,1.12-.585,2.075-1.631,2.075h-.811l-.274-4.726h-.754l.3,5.213h1.339c1.519,0,2.452-.355,2.573-2.34.067-.954.123-1.919.18-2.873m-1.773.367v-.367h-.754a6.732,6.732,0,0,1-.217,2.174,1.3,1.3,0,0,1-.406.655l.161.3a2.343,2.343,0,0,0,.622-.423A3.413,3.413,0,0,0,439.714,486.233Z",
    transform: "translate(467.398 -264.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    className: "cls-1",
    d: "M521.227,488.151v-2.285h-.754v2.662l.754-.377",
    transform: "translate(389.222 -264.994)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    className: "cls-1",
    d: "M544.813,489.239v-.487h-.462V486.61c0-1.7-.924-2.707-2.348-2.707h-.245a5.52,5.52,0,0,0-1.273.189l.14.543a3.148,3.148,0,0,1,1.368-.354c1.1,0,1.527,1.131,1.527,2.274v2.2H540.6v.487h4.214",
    transform: "translate(370.461 -263.154)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    className: "cls-3",
    d: "M248.558,379.77h-2.546v-4.348a2.935,2.935,0,0,1,.924-.123c1.085,0,1.622,1.11,1.622,2.274v2.2m.829.489v-2.63a2.429,2.429,0,0,0-2.442-2.706,5.1,5.1,0,0,0-1.819.3l.132.388v4.648h4.129Z",
    transform: "translate(647.382 -160.977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    className: "cls-1",
    d: "M325.858,379.156v-2.284H325.1v2.661l.754-.377",
    transform: "translate(572.397 -162.804)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    className: "cls-3",
    d: "M353.707,377.574c0,1.01-.416,2.463-1.453,2.463-1.074,0-1.47-1.188-1.47-2.274v-2.241a2.338,2.338,0,0,1,1.2-.233c1.169,0,1.725,1.009,1.725,2.284m.829.056a2.538,2.538,0,0,0-2.555-2.706,4.552,4.552,0,0,0-2.027.376v2.3c0,1.563.848,2.784,2.225,2.784A2.471,2.471,0,0,0,354.537,377.63Z",
    transform: "translate(549.097 -160.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    className: "cls-1",
    d: "M439.318,377.63a2.423,2.423,0,0,0-2.442-2.706,1.6,1.6,0,0,0-1.037.443,1.122,1.122,0,0,0-.971-.4H434.8l-.142.344c.613,0,.679.433.679,1.109,0,.467-.077,1.032-.114,1.5-.075.787-.188,1.564-.3,2.341h.755c.113-.756.225-1.52.3-2.286.047-.521.122-1.043.122-1.563a1.077,1.077,0,0,1,.925-1.11c1.122,0,1.461,1.154,1.461,2.274,0,1.232-.529,2.34-1.689,2.34a1.089,1.089,0,0,1-.4-.144l-.085.521a2.73,2.73,0,0,0,.585.09c1.432,0,2.412-1.032,2.412-2.751",
    transform: "translate(469.678 -160.978)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    className: "cls-3",
    d: "M520.551,380.259h.755v-2.94h-.755Zm3.79,0v-2.63a2.423,2.423,0,0,0-2.443-2.706h-.243a5.494,5.494,0,0,0-1.274.188l.141.544a3.081,3.081,0,0,1,1.368-.356c1.093,0,1.621,1.11,1.621,2.274v2.686h.83Z",
    transform: "translate(389.31 -160.977)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    className: "cls-3",
    d: "M290.763,271.25v-2.629a2.429,2.429,0,0,0-2.441-2.707,4.864,4.864,0,0,0-1.537.3l.17.388v2.983c0,.577-.037,1.4-.7,1.4a1.9,1.9,0,0,1-.425-.077v.266a2,2,0,0,0,.792.2c.952,0,1.084-.809,1.084-1.741v-3.272a2.739,2.739,0,0,1,.6-.067c1.094,0,1.622,1.109,1.622,2.274v2.684h.829",
    transform: "translate(609.217 -58.773)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_338",
    "data-name": "Rectangle 338",
    className: "cls-1",
    width: 0.755,
    height: 5.214,
    transform: "translate(900.768 207.263)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    className: "cls-3",
    d: "M406.837,267.862h-.772c-.02.888-.085,1.776-.151,2.652-.085,1.12-.585,2.074-1.632,2.074h-.811l-.273-4.726h-.755l.3,5.214h1.339c1.519,0,2.451-.355,2.574-2.34.066-.955.123-1.919.179-2.874m-1.772.367v-.367h-.754a6.74,6.74,0,0,1-.217,2.175,1.3,1.3,0,0,1-.4.654l.16.3a2.313,2.313,0,0,0,.622-.421A3.415,3.415,0,0,0,405.065,268.229Z",
    transform: "translate(499.885 -60.599)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    className: "cls-1",
    d: "M487.2,271.25v-2.629a2.424,2.424,0,0,0-2.441-2.707h-.245a4.549,4.549,0,0,0-.952.111l.14.544a1.859,1.859,0,0,1,1.047-.278c1.093,0,1.622,1.109,1.622,2.274v2.684h.829",
    transform: "translate(423.83 -58.773)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRashuthamisim);
export default __webpack_public_path__ + "static/media/rashuthamisim.4b858dcbdd919b719f3a157f9910baed.svg";
export { ForwardRef as ReactComponent };